import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import IntroCarousel from "@components/IntroCarousel";
import { INTRO_SEEN_STORAGE_KEY } from "@constants/intro";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  width: 100%;
  background: #fff;
`;

const Intro: FC = () => {
  const navigate = useNavigate();

  const handleComplete = () => {
    try {
      localStorage.setItem(INTRO_SEEN_STORAGE_KEY, "true");
    } catch {
      // ignore storage errors and still navigate
    }
    navigate("/sign-in", { replace: true });
  };

  return (
    <PageContainer>
      <IntroCarousel onComplete={handleComplete} />
    </PageContainer>
  );
};

export default Intro;
